// components/ArtworkNotes/components/NoteCard.tsx
import React from 'react';
import { Note, NoteTypeDto } from '../../models/Note';
import { IconButton, Tooltip } from "@mui/material";
import EditDocumentIcon from '@mui/icons-material/EditDocument';
import DeleteIcon from "@mui/icons-material/Delete";
import { useUser } from '../../components/UserContext';
import { useReferenceData } from '../../components/ReferenceDataContext';
interface NoteCardProps {
    note: Note;
    onEdit: (note: Note) => void;
    onDelete: (noteId: number) => void;
    disabled?: boolean;
}

const NoteCard: React.FC<NoteCardProps> = ({ note, onEdit, onDelete, disabled = false }) => {
    const { noteTypes, noteTypesState } = useReferenceData();

    const getPriorityColor = (priority: number): string => {
        switch (priority) {
            case 2: return '#ef4444'; // High - red
            case 1: return '#f59e0b'; // Medium - amber
            default: return '#6b7280'; // Low - gray
        }
    };

    function getNoteTypeNameById(
        id: number
    ): string {
        return noteTypes?.find(nt => nt.noteTypeId === id)?.name ?? "";
    }


    const formatDate = (dateString: string): string => {
        return new Date(dateString).toLocaleDateString();
    };

    const { isAdmin, isOwner, isValuer } = useUser();
    const canEditArtwork = isAdmin || isOwner || isValuer;

    return (
        <div className={`note-card ${disabled ? 'disabled' : ''}`}>
            <div className="note-header">
                <div className="note-title-section">
                    <h4>{note.title}</h4>
                    <div className="note-meta">
                        <span className={`note-type type-${getNoteTypeNameById(note.noteTypeId).toLowerCase()}`}>
                            {getNoteTypeNameById(note.noteTypeId)}
                        </span>
                        <span
                            className="priority-dot"
                            style={{ backgroundColor: getPriorityColor(note.priority) }}
                            title={`${['Low', 'Medium', 'High'][note.priority]} Priority`}
                        />
                    </div>
                </div>

                {!disabled && (
                    <div className="note-actions">
                        <Tooltip title="Edit note">
                        <IconButton edge="end" onClick={() => onEdit(note)}>
                            <EditDocumentIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete note">
                        <IconButton edge="end" onClick={() => onDelete(note.id)}>
                            <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                )}
            </div>

            <div className="note-content">
                <p>{note.content}</p>
            </div>

            {note.tags && note.tags.length > 0 && (
                <div className="note-tags">
                    {note.tags.map(tag => (
                        <span key={tag} className="tag">
                            {tag}
                        </span>
                    ))}
                </div>
            )}

            <div className="note-footer">
                <span className="note-date">
                    Updated: {formatDate(note.updatedAt)}
                </span>
            </div>
        </div>
    );
};

export default NoteCard;